var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fl-post-category"},[_vm._v("\n    "+_vm._s(_vm.moduleSettings.sources[parseInt(_vm.postObj.source)].label_position == 0 ? _vm.postLabel : _vm.postTerm)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }